// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_MostrarOcorrenciasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/mostrar_ocorrencias/{id}
 *
 * Returns ocorrencias for cliente and orcamento, merged into a single list
 * with each row tagged via `tipo` ('Cliente' or 'Orçamento').
 */
import type { Orcamentos_MostrarOcorrenciasRow } from './Orcamentos_MostrarOcorrenciasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_MostrarOcorrenciasResponseDados = Orcamentos_MostrarOcorrenciasRow[];

export type Orcamentos_MostrarOcorrenciasResponse = ApiResponse<Orcamentos_MostrarOcorrenciasResponseDados>;

registerResponseContract('Orcamentos_MostrarOcorrenciasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'string',  required: false },
      Owner:     { type: 'string',  required: false },
      OwnerID:   { type: 'number',  required: false },
      User:      { type: 'string',  required: false },
      Content:   { type: 'string',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'object',  required: false },
      user_id:   { type: 'string',  required: false },
      tenant_id: { type: 'string',  required: false },
      tipo:      { type: 'string',  required: false },
    },
  },
})
